import api from "./api";

interface ActorToggleFavoriteProps {
  actorId: string;
}

interface ActorToggleFavoriteParams {
  actor_id: string;
}

const URL = "/actor/toggle-starred";

// 切换演员收藏状态
export const actorToggleFavorite = async (actorId: ActorToggleFavoriteProps["actorId"]) => {
  const params: ActorToggleFavoriteParams = {
    actor_id: actorId,
  };
  const res = await api.post<unknown>(URL, params);
  return res;
};
